export enum TableViewAdministrationState {
  BookingOverview = 'BOOKING_OVERVIEW',
  CampaignOverview = 'CAMPAIGN_OVERVIEW',
  Approval = 'APPROVAL',
  AfterSales = 'AFTER_SALES',
  PartsAgreementsOverview = 'PARTS_AGREEMENTS_OVERVIEW',
}
